<template>
    <div>
        <div class="examine voidedBox" v-if="voided.length!=0">
            <h4>作废申请信息
                <span style="color:#EF7400" v-if="voided.status==1">（待商务审核）</span>
                <span style="color:#EF7400" v-if="voided.status==2">（待财务审核）</span>
                <span style="color:#EF7400" v-if="voided.status==3">（商务审核驳回）</span>
                <span style="color:#00BB5D" v-if="voided.status==4">（财务审核通过）</span>
                <span style="color:#d51313" v-if="voided.status==5">（财务审核驳回）</span>
            </h4>
            <div class="info">
                <div class="item">
                    <label>作废申请日期：</label>
                    <span>{{voided.applicant_time}}</span>
                </div>
                <div class="item">
                    <label>作废申请人：</label>
                    <span>{{voided.applicant_user}}</span>
                </div>
                <div class="item">
                    <label>作废申请发票序列号：</label>
                    <span>{{voided.inv_id}}</span>
                </div>
                <div class="item" style="width:100%">
                    <label>申请原因：</label>
                    <span>{{voided.reason}}</span>
                </div>
            </div>
            <div class="info" v-if="voided.status>1">
                <div class="item">
                    <label>商务审核时间：</label>
                    <span>{{voided.verify_at}}</span>
                </div>
                <div class="item">
                    <label>商务审核人：</label>
                    <span>{{voided.verify_user}}</span>
                </div>
                <div class="item" style="width:100%">
                    <label>商务审核意见：</label>
                    <span>{{voided.verify_note}}</span>
                </div>
            </div>
            <div class="info" v-if="voided.status>3">
                <div class="item">
                    <label>财务审核时间：</label>
                    <span>{{voided.confirm_verify_at}}</span>
                </div>
                <div class="item">
                    <label>财务审核人：</label>
                    <span>{{voided.confirm_verify_user}}</span>
                </div>
                <div class="item" style="width:100%">
                    <label>财务审核意见：</label>
                    <span>{{voided.confirm_verify_note}}</span>
                </div>
            </div>
            <div class="info" v-if="(userInfo.role_id == 10) || (userInfo.role_id == 21) || (userInfo.role_id == 18 && voided.pre_audit_status)">
                <div class="item" style="width:100%">
                    <label>预审结果：</label>
                    <span>{{voided.pre_audit_status==1?'通过': voided.pre_audit_status == 2 ? '驳回' : ''}}</span>
                </div>
                <div class="item" style="width:100%">
                    <label>预审意见：</label>
                    <span>{{voided.pre_audit_content}}</span>
                </div>
            </div>
            <div>
                <div v-for="(item,index) in voided.files" :key="index">
                    <div class="enclosure" @click="lookFile(item)">
                        <i class="el-icon-search"></i>
                        <span>{{item&&item.split('/')&&item.split('/')[item.split('/').length-1]?item.split('/')[item.split('/').length-1]:'附件'}}</span>
                    </div>
                    <div class="enclosure" @click="downLoadFiles(item)">
                        <i class="el-icon-download"></i>
                        <span>下载附件</span>
                    </div>
                </div>
            </div>
            <div style="margin-top:10px" v-if="(userInfo.role_id == 15 && voided.status == 1) || (userInfo.role_id == 10 && voided.status == 2) || (userInfo.role_id == 21 && voided.status == 2)">
                <label style="vertical-align: top;">发票作废审核备注：</label>
                <el-input
                    class="textarea"
                    type="textarea"
                    placeholder="请输入审核原因"
                    v-model="voided_verify_reason">
                </el-input>
            </div>
            <!-- S 财务预审 -->
            <div style="border-top: 1px solid #eee;" v-if="(userInfo.role_id == 18 && voided.status == 2 && !voided.pre_audit_status)">
              <div style="margin-top:20px">
                <label>预审：</label>
                <el-radio-group v-model="preAudit.status">
                  <el-radio :label="1">通过</el-radio>
                  <el-radio :label="2">驳回</el-radio>
                </el-radio-group>
              </div>
              <div style="margin-top:10px">
                  <label style="vertical-align: top;">预审备注：</label>
                  <el-input class="textarea" type="textarea" maxlength="300" placeholder="请输入审核原因" v-model="preAudit.content"> </el-input>
              </div>
            </div>
            <!-- E 财务预审 -->
        </div>
        <div slot="footer" style="text-align: center;margin-top:40px" v-if="voided.length!=0">
            <!-- S 财务预审 -->
            <template v-if="(userInfo.role_id == 18 && voided.status == 2 && !voided.pre_audit_status)">
              <el-button type="primary" size='small' @click="preAuditSubmit">提交</el-button>
            </template>
            <!-- E 财务预审 -->

            <div v-if="userInfo.role_id==15" style="display:inline-block">
                <el-button type="primary" size='small' @click="verifyVoidedInvoice(2)" v-if="voided.status==1">发票作废 审核通过</el-button>
                <el-button type="primary" size='small' @click="verifyVoidedInvoice(3)" style="background:#d51313;border-color:#d51313" v-if="voided.status==1">发票作废 审核不通过</el-button>
            </div>
            <div v-if="userInfo.role_id==10 || userInfo.role_id==21" style="display:inline-block">
                <el-button type="primary" size='small' @click="verifyVoidedInvoice(4)" v-if="voided.status==2">发票作废 审核通过</el-button>
                <el-button type="primary" size='small' @click="verifyVoidedInvoice(5)" style="background:#d51313;border-color:#d51313" v-if="voided.status==2">发票作废 审核不通过</el-button>
            </div>
        </div>
        <div slot="footer" style="text-align: center;margin-top:40px" v-if="routeName!='/invoiceExamine'">
            <el-button size='mini' type="primary" v-if="invoice_status==4&&voided.length==0" style="background:#d51313;border-color:#d51313" @click="voidedOrderAdd(1)">申请作废</el-button>
            <el-button size='mini' type="primary" v-if="invoice_status==4&&(voided.status==3||voided.status==5)" style="background:#d51313;border-color:#d51313" @click="voidedOrderAdd(2)">重新申请作废</el-button>
        </div>
        <el-dialog title="申请作废" :visible.sync="voidedOrderFlag" width="900px" top="10vh" :close-on-click-modal='false'>
            <div style="margin-bottom:15px">
                <label class="voided_label">作废原因：</label>
                <el-input
                    style="width:60%"
                    class="textarea"
                    type="textarea"
                    placeholder="请输入作废原因"
                    v-model.trim="voided_reason">
                </el-input>
            </div>
            <add-file @file='(val)=>{voidedFile=val}' :fileOtherList='fileOtherList' :uploadOtherFile='voidedFile'></add-file>
            <div style="text-align:center;margin-top:30px">
                <el-button size='small' @click="voidedOrderFlag=false">取消</el-button>
                <el-button type="primary" size='small' @click="voidedOrderAddEvent">作废</el-button>
            </div>
        </el-dialog>
        <!-- <look-file v-if="lookFlag" :fileUrl = 'fileUrl' @close="()=>{lookFlag=false}"></look-file> -->
    </div>
</template>
<script>
import addFile from '@/components/assembly/addFile'
// import lookFile from '@/components/assembly/lookFile'
export default {
    components:{
        addFile,
        // lookFile
    },
    props:['voided','invoice_status'],
    data(){
        return{
            voided_verify_reason:'',
            voidedOrderFlag:false,
            voided_reason:'',
            userInfo:{},
            routeName:'',
            id:'',
            resetUpdate:false,
            lookFlag:false,
            fileUrl:'',
            fileOtherList:[],
            uploadOtherFile:[],
            voidedFile:[],
            preAudit: {//财务预审
              status: '',
              content: ''
            },
        }
    },
    created(){
        this.id = this.$route.params.invoice_id;
        this.routeName = this.$route.name
        this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    },
    mounted(){
    },
    methods:{
      /**提交预审 */
      preAuditSubmit(){
        if (this.preAudit.status == '' || !this.preAudit.status) {
          this.$message.warning('请选择预审结果')
          return
        }
        if (this.preAudit.status == 2 && (this.preAudit.content == '' || !this.preAudit.content)) {
          this.$message.warning('请输入审核意见')
          return
        }
        this.$loading(this.$loadingConfig);
        this.$axios.post(this.URL.BASEURL + this.URL.preAuditRecordSave,{
            type: 4,
            data_id_list: [ this.voided.id ],
            status: this.preAudit.status,
            content: this.preAudit.content,
        }).then((res) => {
            var res=res.data;
            this.$loading(this.$loadingConfig).close();
            if(res&& res.errno == 0){
              if(this.$route.name == '/invoiceExamine'){
                  this.$router.push({path:'/invoiceExamine'})
              }else{
                  this.$router.push({path:'/myInvoiceApply'})
              }
            }else {
              this.$message({
                  message: res.err,
                  type: 'warning'
              })
            }
        }).catch(()=>{
          this.$loading(this.$loadingConfig).close();
        })
      },
        lookFile(data){//查看文件
            this.fileUrl = data;
            // this.lookFlag = true
            let routeData = this.$router.resolve({
                path: '/lookFile?url='+this.fileUrl,
            })
            this.$winopen(routeData.href)
        },
        verifyVoidedInvoice(status){//发票作废审核
            if((status == 3||status == 5) && (!this.voided_verify_reason || this.voided_verify_reason=='')){
                this.$message({
                    message: '请输入审核原因',
                    type: 'warning'
                })
                return
            }
            this.loading = true;
            this.$axios.post(this.URL.BASEURL + this.URL.verifyVoidedInvoice,{
              id:this.id,
              status:status,
              verify_note:this.voided_verify_reason
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    if(this.$route.name == '/invoiceExamine'){
                        this.$router.push({path:'/invoiceExamine'})
                    }else{
                        this.$router.push({path:'/myInvoiceApply'})
                    }
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        voidedOrderAdd(status){//申请作废
            if(status==2){
                this.resetUpdate = true
            }
            this.voidedOrderFlag = true
        },
        voidedOrderAddEvent(){
            if(this.voided_reason==''){
                this.$message({
                    message: '请输入作废原因',
                    type: 'warning'
                })
                return
            }
            if(this.voidedFile.length==0){
                this.$message({
                    message: '请上传作废文件',
                    type: 'warning'
                })
                return
            }
            this.$confirm('确定要作废该发票吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                var apiAxios = this.URL.voidedOrderAdd;
                if(this.resetUpdate){
                    apiAxios = this.URL.voidedOrderUpdate
                }
                this.$axios.post(this.URL.BASEURL + apiAxios,{
                    id:this.id,
                    reason: this.voided_reason,
                    files: this.voidedFile
                }).then((res) => {
                    var res=res.data;
                    this.loading = false;
                    if(res&& res.errno == 0){
                        this.$message({
                            message: '提交成功',
                            type: 'warning'
                        })
                        this.voidedOrderFlag = false
                        this.$emit("uploadInvoiceDetail")
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                    this.loading = false
                })
            })
        },
        downLoadFiles(data){//下载
            var url = data.replace("/^(http|https):\/\//", window.location.protocol+'//');
            var doc_name = (url.split('/'))[url.split('/').length-1]
            this.ajax(url, (xhr) => {
                this.downloadFile(xhr.response,doc_name)
            }, {
                responseType: 'blob'
            })
        },
        downloadFile(content, filename) {
            var a = document.createElement('a')
            var blob = new Blob([content])
            var url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
        },
        ajax(url, callback, options) {
            window.URL = window.URL || window.webkitURL
            var xhr = new XMLHttpRequest()
            xhr.open('get', url, true)
            if (options.responseType) {
                xhr.responseType = options.responseType
            }
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    callback(xhr)
                }
            }
            xhr.send()
        },
    },
    watch:{
        voided(){
            if(this.voided&&this.voided.status){
                this.voided_reason = this.voided.reason;
                this.voidedFile = this.voided.files
                this.voided.files.forEach((item,index) => {
                    this.fileOtherList.push({name:item&&item.split('/')&&item.split('/')[item.split('/').length-1]?item.split('/')[item.split('/').length-1]:'附件',url:item})
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import './invoiceDetail.scss';
.voidedBox{
    border-top: 1px solid #eee;
    margin-top:10px;
    padding-top: 10px;
    h4{
        margin-left: 23px;
        font-size: 16px;
        font-weight: bold;
        color: #333;
        line-height: 30px;
        margin-bottom: 10px;
        span{
            font-size: 14px;
        }
    }
    .info{
        margin-bottom: 15px;
        .item{
            display: inline-block;
            width: 30%;
            span{
                color:#666;
                font-size: 14px;
            }
        }
    }
}
.voided_label{
    display: inline-block;
    width: 80px;
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/newBilling/invoice/voided.vue